<template>
  <div>
    <v-toolbar flat style="margin-left: -10px;padding: 0 85px 0 0;background-color:transparent;">
      <v-toolbar-title><h5 style="font-weight: 500;color:rgba(0, 0, 0, 0.47);font-size: 12px"><v-icon style="font-size: 20px;">mdi-format-list-text</v-icon> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t('menuType.formCio') }}&nbsp;&nbsp;&nbsp;&nbsp;</h5></v-toolbar-title>
      <v-divider vertical  style="margin: 0 10px 0 10px;"/>
      <!-- <template>        
        <v-btn-toggle
          v-model="icon" 
          @change="handleChangeIsModified"
        > 
          <v-btn :value="'mdi-information'" @click="content.FormIcon = 'mdi-information'" text>
            <v-icon>mdi-information</v-icon>
          </v-btn>
          <v-btn :value="'mdi-file-document-edit'" @click="content.FormIcon = 'mdi-file-document-edit'" text>
            <v-icon>mdi-file-document-edit</v-icon>
          </v-btn>
          <v-btn :value="'mdi-silverware-fork-knife'" @click="content.FormIcon = 'mdi-silverware-fork-knife'" text>
            <v-icon>mdi-silverware-fork-knife</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template> -->
    </v-toolbar>
    <v-select 
      v-model="content.FormCioFieldsConfig"
      :items="forms"
      :label="$t('dtouch.formCio.form', locale)"
      item-text="Name"
      item-value="ID"
      outlined
      dense
      hide-details
      @change="handleChangeIsModified"
    />
    <!-- <v-text-field
      v-model="content.FormDestinationMail"
      :counter="250"
      :label="$t('form.formDestinationMail')"
      required
    />
    <v-checkbox
      v-show="!collapseContent"
      v-model="content.FormRoomNumber"
      :value="content.FormRoomNumber"
      :label="$t('form.formRoomNumber')"
      @change="handleChangeIsModified"
    />
    <v-checkbox
      v-show="!collapseContent"
      v-model="content.FormDateTime"
      :value="content.FormDateTime"
      :label="$t('form.formDateTime')"
      @change="handleChangeIsModified"
    />
    <timetable
      v-if="content.FormDateTime"
      v-model="content.FormTimetable"
    />
    <div style="background-color: #CCCCCC; padding:10px;margin-top:10px;">
    <v-checkbox
      v-show="!collapseContent"
      v-model="content.FormNumberOfPeople"
      :value="content.FormNumberOfPeople"
      :label="$t('form.numOfItems')"
      @change="handleChangeIsModified"
    />
    <translate
      v-if="content.FormNumberOfPeople"
      v-show="!collapseContent"
      v-model="content.FormLblNumberOfItem"
      :languages="languages"
      :label="$t('form.lblNumOfItems')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    />
    <v-text-field
      v-if="content.FormNumberOfPeople"
      v-show="!collapseContent"
      :label="$t('form.formLimitNumberOfItem')"
      v-model="content.FormLimitNumberOfItem"
      type="number"
    />
    </div>
    <translate
      v-show="!collapseContent"
      v-model="content.FormTextBtn"
      :languages="languages"
      :label="$t('form.formTextBtn')"
      @input="handleChangeIsModified"
      style="padding: 0 10px 0 10px;"
    /> -->
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import Translate from '@/components/Translate'
  import CustomColorPicker from '@/components/CustomColorPicker'
  import Timetable from '@/components/timetable/Index'
  export default {
    components: {
      Translate,
      CustomColorPicker,
      Timetable
    },
    props: {
      content: {
        type: Object,
        required: true
      },
    },
    data: () => ({
      icon: null,
      forms: null,
    }),
    computed: {
      ...mapState('app',['collapseContent']),
      languages () {
        return this.$store.state.app.Languages
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
    },
    mounted () {
      this.icon = this.content.FormIcon
      this.handleGetForms()
    },
    methods: {
      handleGetForms () {
        api.getAll(`enterprises/${this.enterpriseID}/form-cio`, true).then(response => {
          this.forms = response
        })
      },
      handleChangeIsModified () {
        this.$store.state.app.isModified = true
      }
    }
  }
</script>
